import Component from '../core/Component';
import $ from 'jquery';
import enquire from 'enquire.js';
import { places } from '../data/places';
import { categories } from '../data/places';
import { queries, basePath } from '../core/config';
import 'js-info-bubble';

export default class Map extends Component
{
    constructor($element)
    {
        super($element)
        // filter places by city
        this.city = this.$element.data('city')
        this.places = places.filter((place) => {
            return place.city == this.city
        })
    }

    prepare()
    {
        setTimeout(() => {
            enquire.register(queries.mediumUp, {
                match: () => {
                    this.reset()
                    this.initMap()
                }
            });
            enquire.register(queries.smallWideMax, {
                match: () => {
                    this.reset()
                    this.initList()
                }
            });
        }, 100)
    }

    initMap () {

        this.initCategories()
        this.$map = $('<div class="map__gmap"></div>')
        this.$element.append(this.$map)

        var mapCenter = { lat: 50.092564, lng: 14.439931 }
        var zoom = 15
        if (this.$element.data('city') == 1) {
            mapCenter = { lat: 49.208613, lng: 16.590547 }
            zoom = 15
        }
        if (this.$element.data('city') == 2) {
            mapCenter = { lat: 49.836043, lng: 18.287896 }
            zoom = 15
        }

        if (this.$element.data('city') == 3) {
            mapCenter = { lat: 48.982751, lng: 14.470247 }
            zoom = 15
        }

        // create map
        this.map = new google.maps.Map(this.$map[0], {
            center: mapCenter,
            zoom: zoom,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            scrollwheel: false
        });

        // create pins
        const pins = {}
        categories.forEach(function (category) {
            let pin
            if (category.id == 0) {
                pin = new google.maps.MarkerImage(`${basePath}/assets/frontend/img/pins/${category.id}.png`, null, null, new google.maps.Point(18, 61), new google.maps.Size(68,61))
            } else {
                pin = new google.maps.MarkerImage(`${basePath}/assets/frontend/img/pins/${category.id}.png`, null, null, null, new google.maps.Size(56,49))
            }
            pins[category.id] = pin
        })

        this.markersArray = []
        this.infoBubbleArray = []
        // create markers
        places.forEach((place,i) => {
            var marker = new google.maps.Marker({
                position: { lat: place.lat, lng: place.lng },
                map: this.map,
                flat: true,
                title: place.name,
                icon: pins[place.type],
                category: place.type,
                shape: {
                    type: 'rect',
                    coords: [0,0,35,50]
                },
                zIndex: i
            })

            marker.setMap(this.map)

            marker.data = {
                id: place.id
            }

            this.markersArray.push(marker)

            marker.setVisible(true)

            // opening initial
            marker.addListener('click', () => {
                var infoBubble = this.createBubble(place, marker)
                this.infoBubbleArray.push(infoBubble)
                this.infoBubbleArray.forEach((ib) => {
                    ib.close()
                })
                infoBubble.open(this.map, marker)
            })

            // closing infoBubbles
            //this.$map.on('click', () => {
            //    this.infoBubbleArray.forEach((ib) => {
            //        ib.close()
            //    })
            //})
        })
    }

    createBubble (place, marker) {
        var style = 'width: 280px; height: 240px; margin: 0; box-shadow: 0 14px 30px rgba(0,0,0,.1); text-align: center; position: relative; background: #fff; overflow: hidden; border-radius: 2px'
        var h2Style = 'margin: 0 auto; color: #43434b; font-size: 18px; line-height: 30px; font-family: Univers, sans-serif; padding: 20px 20px 0'
        var lineStyle = 'width: 40px; height: 2px; background: linear-gradient(to right, #00c1b5, #fff); margin: 14px auto 14px;'
        var closeStyle = 'width: 26px; height: 26px; border-radius: 50%; position: absolute; top: 0; right: 0; background: #e4fbf9; color: #00c1b5; font-size: 12px; line-height: 26px; text-align: center; cursor: pointer'
        var pStyle = 'color: #7f929c; font-size: 15px; line-height: 24px; font-family: Helvetica, Arial, sans-serif; padding: 0 20px; height: 60px'
        var linkStyle = 'display: block; position: absolute; bottom: 0; left: 0; right: 0; background: #f6f7f9; font-size: 13px; color: #7f929c; height: 70px; line-height: 70px; text-decoration: none'
        var arrowStyle = 'bottom: -4px; left: 90px; border: solid transparent; height: 0; width: 0; position: absolute; pointer-events: none; border-color: rgba(255, 255, 255, 0); border-top-color: #ffffff; border-width: 7px; margin-left: -7px;'

        var contentString = '<div id="infoBubble" style="'+ style + '">'+
            '<h2 style="'+ h2Style + '">' + place.name + '</h2>'+
            '<div style="' + lineStyle + '"></div>' +
            '<p style="'+ pStyle + '">' + place.description + '</p>';

        if (place.url != null && place.url != '') {
            contentString += '<a class="infoBubble__link" style="'+ linkStyle + '" href="' + place.url + '" target="_blank">Zobrazit web<svg xmlns="http://www.w3.org/2000/svg" style="margin: 0 0 0 20px" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="5" height="8" viewBox="0 0 5 8"><defs><style>.cls-2 {fill: #00c1b6;margin: 0 0 0 10px;}</style></defs><path d="M1.143,0.108 C1.002,-0.041 0.773,-0.041 0.633,0.108 C0.633,0.108 0.123,0.644 0.123,0.644 C-0.018,0.791 -0.018,1.031 0.123,1.178 C0.123,1.178 2.581,3.724 2.581,3.724 C2.581,3.724 0.103,6.291 0.103,6.291 C-0.039,6.440 -0.039,6.679 0.103,6.827 C0.103,6.827 0.613,7.363 0.613,7.363 C0.752,7.510 0.981,7.510 1.123,7.363 C1.123,7.363 4.368,3.992 4.368,3.992 C4.508,3.844 4.508,3.604 4.368,3.456 C4.368,3.456 1.143,0.108 1.143,0.108 Z" id="path-1" class="cls-2" fill-rule="evenodd"/></svg></a>';
        }
        contentString += '</div>' +
        '<div class="infoBubble__close" style="' + closeStyle + '">&times;</div>' +
        '<div style="' + arrowStyle + '"></div>';


    var infoBubble = new InfoBubble({
            map: this.map,
            content: contentString,
            position: new google.maps.LatLng(place.lat, place.lng),
            padding: 13,
            backgroundColor: 'transparent',
            borderRadius: 4,
            arrowSize: 10,
            borderWidth: 0,
            minWidth: 306,
            minHeight: 263,
            borderColor: '#2c2c2c',
            disableAutoPan: true,
            hideCloseButton: false,
            shadowStyle: 0,
            arrowPosition: 30,
            arrowStyle: 0,
            animation: null,
            overflow: 'hidden'
        })

        return infoBubble
    }

    initCategories () {
        this.$categoryList = $('<div class="map__categories"></div>')
        this.$categoryListInner = $('<div class="map__categories__inner"></div>')
        this.$categoryHeadline = $('<div class="map__categories__headline">Vyberte co vás zajímá</div>')

        this.$categoryList.append(this.$categoryListInner)
        this.$categoryListInner.append(this.$categoryHeadline)

        var $categoryItem = $(`<div class="map__category is-active">Vše</div>`)
        $categoryItem.on('click', (event) => {
            this.$categoryList.find('.map__category').removeClass('is-active')
            $(event.target).addClass('is-active')
            this.markersArray.forEach((m) => {
                m.setVisible(true)
            })
            this.infoBubbleArray.forEach((ib) => {
                ib.close()
            })
        })
        this.$categoryListInner.append($categoryItem)

        categories.forEach((category) => {
            if (category.id != 0) {
                var $categoryItem = $(`<div class="map__category">${category.name}</div>`)

                var placesOfCategory = this.places.filter((place) => {
                        return place.type == category.id
                    })
                if (placesOfCategory.length == 0) {
                    return;
                }

                $categoryItem.on('click', (event) => {
                    this.$categoryList.find('.map__category').removeClass('is-active')
                    $(event.target).addClass('is-active')

                    this.markersArray.forEach((m) => {
                        if (m.category == category.id || m.category == 0) {
                            m.setVisible(true)
                        } else {
                            m.setVisible(false)
                        }
                        this.infoBubbleArray.forEach((ib) => {
                            ib.close()
                        })
                    })
                })
                this.$categoryListInner.append($categoryItem)
            }
        })

        this.$element.append(this.$categoryList)
    }

    initList () {
        this.$list = $('<div class="map__list"></div>')
        categories.forEach((category) => {
            if (category.id != 0) {
                var $listItem = $(`<div class="map__list__item"><div class="map__list__head">${category.name}</div></div>`)
                var $listItemBody = $(`<div class="map__list__body"></div>`)

                this.places.forEach((place) => {
                    if (place.type == category.id) {
                        var $listDetail = $(`<div class="map__list__detail"><div class="map__list__detail__head">${place.name}</div><div class="map__list__detail__body">${createDetail(place)}</div></div>`)
                        $listItemBody.append($listDetail)

                        $listDetail.find('.map__list__detail__head').on('click', (event) => {
                            $(event.target).parent().toggleClass('is-active')
                        })
                    }
                })

                $listItem.append($listItemBody)
                $listItem.find('.map__list__head').on('click', (event) => {
                    $(event.target).parent().toggleClass('is-active')
                })
                this.$list.append($listItem)
            }
        })
        this.$element.append(this.$list)

        function createDetail (place) {
            return `<p>${place.description}</p>` +
                   `<table>` +
                       `</tr>` +
                            `<th>Město</th><td>${place.city}</td>` +
                       `</tr>` +
                   `</table>` +
                `<p><a target="_blank" href="http://maps.google.com/?q=${place.lat},${place.lng}">Zobrazit na mapě<i class="icon icon-arrow-right"></i></a></p>`
        }
    }

    reset () {
        this.$element.empty()
    }
}


// WEBPACK FOOTER //
// ./components/Map.js